module.exports = __webpack_public_path__ + "img/pending.23e9ae1a.png";